import React, { useState, useEffect } from 'react';
// import { FaFacebook } from 'react-icons/fa';
import {
  PlatformContainer,
  PlatformHeader,
  PlatformIcon,
  PlatformTitle,
  ProgressContainer,
  ProgressBar,
  ProgressFill,
  ProgressText,
  StepsList,
  StepItem,
  StepNumber,
  StepContent,
  StepText,
  CompletedCheckmark,
  TechCircle,
  AnimatedBorder,
  TechGrid,
  DataStream,
  NavigationButtons,
  NavigationButton
} from './PlatformStyles';

const MetaPlatform = ({ onStepComplete, onNavigateToNextPlatform, activeStep = 0 }) => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    setProgress(100); // Só 1 passo
  }, []);

  return (
    <PlatformContainer>
      <AnimatedBorder color="#1877F3" />
      <TechGrid />
      <DataStream color="#1877F3" />

      <PlatformHeader>
        <PlatformIcon style={{ background: '#1877F3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src="/meta_logo.png" alt="Meta Logo" style={{ width: 36, height: 36, objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
        </PlatformIcon>
        <PlatformTitle style={{ color: '#fff' }}>Meta</PlatformTitle>
      </PlatformHeader>
      
      <StepsList>
        <StepItem active={true} completed={false}>
          
          <StepContent>
            <strong>Conceda acesso na Meta</strong>
            <StepText>
              Para ativar a integração com o Meta, conceda <strong>acesso total</strong> ao e-mail <strong>joaoferrari@journeyagency.com.br</strong> na sua <a href="https://business.facebook.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#1877F3', textDecoration: 'underline' }}>Business Manager</a> do Meta.<br /><br />
              <span style={{ color: '#1877F3', fontWeight: 'bold' }}>Após conceder o acesso, clique em "Avançar" para continuar.</span>
            </StepText>
          </StepContent>
        </StepItem>
      </StepsList>
      <NavigationButtons>
        <NavigationButton
          type="button"
          style={{
            background: 'linear-gradient(135deg, #1877F3, #4C6EF5)',
            color: '#fff',
            fontWeight: 600,
            fontSize: '1.1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            boxShadow: '0 4px 10px rgba(24,119,243,0.25)',
            transition: 'all 0.3s ease',
            marginLeft: 'auto',
            marginRight: 0,
            marginTop: '0',
            marginBottom: '0',
            minWidth: '140px',
            cursor: 'pointer'
          }}
          onClick={() => { onStepComplete(0); onNavigateToNextPlatform(); }}
          aria-label="Avançar para a próxima plataforma"
        >
          Avançar
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 5L12 10L7 15" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </NavigationButton>
      </NavigationButtons>
    </PlatformContainer>
  );
};

export default MetaPlatform;
